import * as Field from '@/components/ui/field'
import { PageSearch } from '@components/PageSearch'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'

/** Keyword search across title, symbol, exchange and description */
export default function SearchIn() {
  const { searchInput, setSearchInput } = useService(useFilters)()

  return (
    <Field.Root>
      <Field.Label>Keyword</Field.Label>
      <PageSearch value={searchInput()} onInput={setSearchInput} placeholder='Title, symbol, exchange, description…' />
    </Field.Root>
  )
}
